'use client';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { MiniCartContextShape } from './types';

const MiniCartContext = React.createContext<MiniCartContextShape>({
  show() {},
  isOpen: false,
  hide() {},
});

const MiniCartProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);

  const show = useCallback(() => {
    setIsOpen(true);
  }, []);

  const hide = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Memoize context value to prevent re-renders when callbacks haven't changed
  const contextValue = useMemo(() => ({ show, hide, isOpen }), [show, hide, isOpen]);

  return <MiniCartContext.Provider value={contextValue}>{children}</MiniCartContext.Provider>;
};

export default MiniCartProvider;

export const useMiniCart = () => useContext(MiniCartContext);